export const sitecoreSupportQuickAction = {
  type: 'ui',
  name: 'Sitecore Support Portal',
  displayName: { name: 'Report issues and manage your support cases' },
  icon: {
    type: 'mdi',
    src: 'mdiLifebuoy',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://support.sitecore.com/csm?utm_source=cloud-portal&utm_medium=help-section',
  },
};
